import { Controller } from "@hotwired/stimulus"

// Shows/hides the principal_id field based on the selected principal_type.
// Organisation-wide shares need no ID; user/branch shares require one.
export default class extends Controller {
  static targets = ["typeSelect", "idField"]

  connect() {
    this.toggleId()
  }

  toggleId() {
    const type = this.typeSelectTarget.value
    const needsId = type === "user" || type === "branch"
    this.idFieldTarget.classList.toggle("hidden", !needsId)
  }
}
